import { Boost, Engage, Marketing, Staffroster, Support, Swimintegration, Swimlandpageimg, swimlandpageimg, Swimmers, Swimprofiles, Swimscheded, Swimscheduling, Swimtracking } from "../assets/images/images";

const swimmingPoolData = {
    heading: "The Best Software For Swimming Pool Management",
    subtitle:
        "EasyMembr brings you a powerful and easy-to-use software solution designed specifically for swimming pool facilities. From managing swim class schedules and memberships to handling payments and staff shifts—our platform helps you focus more on service and safety, and less on admin work.",
    trialText: "Get Started Now",
    demoText: "Book A Demo",
    imageSrc: Swimlandpageimg,
    infoItems: ["No Card Required", "Cancel Anytime", "Affordable Pricing"],
    FeatureHead: "Features of Swimming Pool Management: Organized Sessions & Member Experience",
    FeatureDesc: "Discover powerful tools that help streamline your swimming pool operations and improve customer satisfaction.",
    FeaturesDetails: [
        {
            id: 1,
            title: "Class Scheduling & Lane Management",
            description: [
                "Easymembr lets you organize swim classes by skill levels, age groups, and coaches effortlessly.",
                "Assign and manage lane usage efficiently to prevent conflicts and maximize utilization.",
                "Enable users to view and book sessions online via the web portal or mobile app.",
            ],
            image: Swimscheded
        },
        {
            id: 2,
            title: "Member Profiles and Attendance Tracking",
            description: [
                "Store member details, medical information, skill levels, and attendance history.",
                "Offer personalized class recommendations based on swim level and goals.",
                "All data is encrypted and compliant with privacy standards to ensure secure access.",
            ],
            image: Swimprofiles
        },
        {
            id: 3,
            title: "Flexible Payment Integration and Billing Automation",
            description: [
                "Integrate with top payment gateways to support secure online transactions.",
                "Automate recurring billing for memberships, swim packages, and locker rentals.",
                "Track overdue payments and send automated reminders to improve cash flow.",
            ],
            image: Swimintegration
        },
        {
            id: 4,
            title: "Performance Tracking & Health Reports",
            description: [
                "Monitor swim progress, attendance consistency, and individual milestones.",
                "Generate customizable reports for health check compliance and class effectiveness.",
                "Use analytics to optimize class structure, staffing, and lane allocation.",
            ],
            image: Swimtracking
        },
        {
            id: 5,
            title: "Mobile App for Swimmers, Parents & Staff",
            description: [
                "Offer a branded mobile app for checking schedules, bookings, and class feedback.",
                "Send notifications about pool timings, closures, and health tips.",
                "Allow coaches to mark attendance and update swim progress on the go.",
            ],
            image: Swimmers
        },
        {
            id: 6,
            title: "Staff Roster Management and Payroll",
            description: [
                "Manage lifeguard and coach schedules to ensure safe and efficient coverage.",
                "Track staff shifts, attendance, and roles automatically.",
                "Generate accurate payroll reports based on hours, sessions, and bonuses.",
            ],
            image: Staffroster
        },
    ],
    HighlighCardDetails: [
        {
            id: 1,
            subtitle: "BEST POOL SOFTWARE",
            title: "Book a Demo Now!",
            description: [
                "Take control of your pool operations with our all-in-one software. Try it free and see the difference in efficiency and safety!"
            ],
            image: "https://fitgymsoftware.com/images/swimming-pool-software/cta-pool.webp",
            links: [
                "Get Full Access Now!",
                "Book A Demo",
                "Check Pricing"
            ],
        }
    ],

    AdvantageHeadText: "Advantages of Our Swimming Pool Management Software",
    AdvantageDescText: "Simplify your swim facility operations with software that boosts safety, improves scheduling, and keeps your pool members engaged.",

    featuresData: [
        {
            title: "Hassle-Free Onboarding & Migration",
            description: [
                "Easily transfer data from spreadsheets or older systems with help from our team.",
                "Visualize trends in attendance, earnings, and program performance over time.",
                "Customize dashboards to reflect your facility’s real-time status and goals."],
            icon: Marketing
        },
        {
            title: "Engagement-Driven Member Management",
            description: [
                "Send swim tips, session reminders, and motivational messages to members.",
                "Offer feedback on swim progress and promote next-level courses.",
                "Reward consistent swimmers with loyalty benefits and personalized offers."],
            icon: Engage
        },
        {
            title: "Efficient Class & Pool Slot Allocation",
            description: [
                "Automatically assign swimmers to lanes based on age and skill level.",
                "Keep track of pool occupancy and prevent overcrowding.",
                "Sync indoor and outdoor pool schedules with real-time visibility."],
            icon: Boost
        },
        {
            title: "Communication & Marketing Tools",
            description: [
                "Send emails, WhatsApp messages, or SMS for updates and promotions.",
                "Run seasonal or skill-based offers to attract more swimmers.",
                "Track engagement results with built-in campaign analytics."],
            icon: Marketing
        },
        {
            title: "Dedicated Support & Compliance Tracking",
            description: [
                "Multi-language customer support for local and international swim centers.",
                "Track lifeguard certifications and student health clearances automatically.",
                "Receive alerts and updates to ensure compliance with safety regulations."],
            icon: Support
        },
    ]
};

export default swimmingPoolData;
